import React from 'react';

import ModalTemplate from '../../../../components/modal';
import {AppFormSubmitButton} from '../../../../components/forms';
import './styles.scss';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Row} from '../../../../components/layout';
import Icon from '../../../../components/icon/index';
import {Icons} from '../../../../util/icons';
import colors from '../../../../util/colors';
import {strings} from '../../../../util/strings';

interface ChangeSuccessProps {
  showModal: boolean;
  setShowModal: any;
  strings: any;
  messageLabels: typeof strings.pt.messages;
  ibanStrings: any;
}

function ChangeSuccessModal({
  showModal,
  setShowModal,
  strings,
  messageLabels,
  ibanStrings,
}: ChangeSuccessProps) {
  return (
    <div className="change-success-modal-content">
      <ModalTemplate
        show={showModal}
        onHide={() => setShowModal(null)}
        cross={true}
        hideFooter={true}>
        <div className="change-success-modal-form-container">
          <div className="submitted-modal-container">
            <Icon
              name={Icons.SUCCESS}
              width={'25'}
              height={'25'}
              color={colors.green}
              changeViewbox={true}
            />
            <Row>
              {ibanStrings?.ibanRefunds_form === 'servio'
                ? messageLabels?.updatedBankAccountData
                : messageLabels?.updatedIBAN}
            </Row>
            {ibanStrings?.ibanRefunds_form !== 'servio' && (
              <Row>{messageLabels?.updatedIBAN_moreInfo}</Row>
            )}
            <Row className="submitted-modal-button-row">
              <AppFormSubmitButton
                title="Ok"
                className="stepper-continue-button"
                variant="secondary"
                onClick={() => {
                  setShowModal(null);
                }}
              />
            </Row>
          </div>
        </div>
      </ModalTemplate>
    </div>
  );
}

const mapStateToProps = ({strings}: any) => ({
  strings: strings.value.pt.myData,
  messageLabels: strings.value.pt.messages,
  ibanStrings: strings.value.pt.ibanRefunds,
});

export default compose(connect(mapStateToProps)(ChangeSuccessModal));
